
/* Calc body modal content */
export const getBodyModalHeight = (
    id: string
) => {
    const bodyModalHeight = document.getElementById(id)?.clientHeight;
    return bodyModalHeight? bodyModalHeight + 150 : 500;
}